<script>
  import { FirebaseApp, User, Doc, Collection } from "sveltefire";

  import firebase from "firebase/app";
  import "firebase/firestore";
  import "firebase/auth";
  import "firebase/performance";
  import "firebase/analytics";

  let firebaseConfig = {
    apiKey: "AIzaSyAVs4uYFEGX3RpoXqN0rKE2GpmZ8hhKXes",
    authDomain: "sallyfrancesco-e1109.firebaseapp.com",
    projectId: "sallyfrancesco-e1109",
    storageBucket: "sallyfrancesco-e1109.appspot.com",
    messagingSenderId: "727035319098",
    appId: "1:727035319098:web:7baa4d62bf8dc4fd6fb603"
  };

  firebase.initializeApp(firebaseConfig);

  var mode = 'party';
  var language = 'eng';

</script>

<style>

@font-face {
  font-family: 'DreamAvenue';
  src: url('../DreamAvenue.ttf') format('truetype'); /* IE9 Compat Modes */
}

@font-face {
  font-family: 'Alice';
  src: url('../Alice-Regular.ttf') format('truetype'); /* IE9 Compat Modes */
}

@font-face {
  font-family: 'Ovo';
  src: url('../Ovo-Regular.ttf') format('truetype'); /* IE9 Compat Modes */
}

h1 {
  font-family: 'DreamAvenue';
  font-size: 192;
  text-align: center;
  color: #274A46;
  margin-top: 16px;
  margin-bottom: 36px;
}

p {
  font-family: 'Alice';
}

a {
  font-family: 'Alice';
}

ul#menu li {
  font-family: 'Ovo';
  font-size: 14px;
  display : inline;
  height: 48px;
  margin-left: 4px;
  margin-right: 4px;
  text-overflow: clip;
  display: inline-block;
  text-overflow: "";
  vertical-align: center;
}

ul#lang li {
  font-family: 'Ovo';
  font-size: 32px;
  display : inline;
  margin-left: 16px;
  margin-right: 16px;
  text-overflow: clip;
  display: inline-block;
  vertical-align: center;
}

li a {
  color: black;
  padding: 8px;
  border-radius: 8px;
  background-color: #eeeeee;
}

.active {
  background-color: #274A46;
  color: white;
  border-radius: 8px;
  font-weight: bold;
}

#party {
  text-align: center;
}

#rsvp {
  text-align: center;
}

#getthere {
}

#italy {
}

#beppe {
  text-align: center;
}

ul {
  padding: 0px;
  width: 90%;
  text-align: center;
  margin: auto;
}

hr {
  margin: auto;
  margin-bottom: 36px;
  margin-top: 36px;
  width: 80%;
}

</style>

<main>

  <!-- 1. 🔥 Firebase App -->
  <FirebaseApp {firebase}>
  <div class="container">
    <h1>Sally and Francesco</h1>

    <ul id="menu">
      <li><a href="/" on:click|preventDefault={()=>mode = "party"} class={mode == "party" ? "active" : ""}>The party</a></li>
      <li><a href="/" on:click|preventDefault={()=>mode = "rsvp"} class={mode == "rsvp" ? "active" : ""}>RSVP</a></li>
      <li><a href="/" on:click|preventDefault={()=>mode = "getthere"} class={mode == "getthere" ? "active" : ""}>How to Get There</a></li>
      <!-- <li><a href="/" on:click|preventDefault={()=>mode = "map"}>Map of Guests</a></li> |  -->
      <li><a href="/" on:click|preventDefault={()=>mode = "italy"} class={mode == "italy" ? "active" : ""}>Italy Trip Ideas</a></li>
      <li><a href="/" on:click|preventDefault={()=>mode = "beppe"} class={mode == "beppe" ? "active" : ""}>Beppe</a></li>
    </ul>

    <ul id="lang">
      <li><a href="/" on:click|preventDefault={()=>language = "ita"} class={language == "ita" ? "active" : ""}>🇮🇹</a></li>
      <li><a href="/" on:click|preventDefault={()=>language = "kor"} class={language == "kor" ? "active" : ""}>🇰🇷</a></li>
      <li><a href="/" on:click|preventDefault={()=>language = "eng"} class={language == "eng" ? "active" : ""}>🇺🇸</a></li>
    </ul>

    <hr>

    {#if mode == 'party'}

      <div id="party">
        <img src="/IMG_0424.jpg" alt="Town"/><br/>
        {#if language == 'eng'}
          <br>
          <p>Our wedding will take place on September 3, 2022 at <b>4.00PM</b> alla fortezza di <a href="https://www.san-leo.it/visita-san-leo/il-forte-rinascimentale/" target="blank">San Leo</a>, Italy.</p>

          <div style='border:1px; background-color: #fff0b5; border-radius: 16px; padding: 12px'>
            <p><b>Schedule</b></p>
            <b>☔️ IT WILL RAIN, WE ARE DOING THE plan B ☔️</b>
            <p><b>4:30pm Ceremony AT, THE Palazzo Mediceo San Leo, Piazza Dante Alighieri</b></p>
            <p><b>5pm</b> Aperitivo/Snack, Castle tours</p>
            <p><b>7pm</b> Dinner</p>
            <p><b>10pm</b> Cake</p>
            <p><b>10pm</b> Music and Open Bar</p>
            <p><b>11:30pm-???</b> Party</p>
          </div>

          <br>
          <b>August Update</b>
          <li>It is reccomended to park at the town parking <a href="https://bit.ly/3AzjNxu">https://bit.ly/3AzjNxu</a><b>We have parking passes in PDF to print, ping us for information!</b></li>
          <li>If you are renting a car or driving and staying at the hotel, the hotel will provide parking passes. Upon arrival at the San Leo Albergo Diffuso, leave your car at the gate and call or text the hotel at +39 389 543 5755. Then, you can check in, drop off your luggage, and receive the parking pass to go park your car.</li>
          <li>If you have not yet decided what to wear, optionally you are suggested to wear something green, the theme color (even an accessory).</li>

          <br>
          <b>July Update</b>
          <br>

          <p>We kindly suggest that you do not bring physical gifts to us in Italy, since we will be traveling back 😊✈️.</p> 
          <p>If you would like to contribute to our honeymoon in Greece:</p>
          <p>PayPal <a href="https://paypal.me/sallyfrancesco">https://paypal.me/sallyfrancesco</a></p>
          <p>IBAN IT84F 02008 32974 001134845193, Francesco Rossi, Unicredit</p>

          <br>

          <b>Transportation update</b>
          <p>The bus to San Leo will be leaving from Bologna at <b>1 PM</b> on September 2nd at Autostazione di Bologna , Piazza XX Settembre, 6, 40121 Bologna (Bo) and will take everyone to the hotel. It will take approximately 2 hours.</p>
          <p>It will take everyone from San Leo back to the same station in Bologna on September 4, leaving at 12.30PM.</p>


        {:else if language == 'ita'}
          <br>

          <p>Il nostro matrimonio sara' il 3 Settembre 2022 alle ore 4.00PM, at the <a href="https://www.san-leo.it/visita-san-leo/il-forte-rinascimentale/" target="blank">San Leo</a> castle.</p>


          <div style='border:1px; background-color: #fff0b5; border-radius: 16px; padding: 12px'>
            <p><b>Schedule</b></p>
            <b>☔️ PIOVE, FACCIAMO IL plan B ☔️</b>
            <p><b>4:30pm cerimonia al, Palazzo Mediceo San Leo, Piazza Dante Alighieri</b></p>
            <p><b>17:00-19:00</b> Aperitivo/Snack, Castle tours</p>
            <p><b>19:30-22:00</b> Cena</p>
            <p><b>22:00</b> Torta</p>
            <p><b>22:00-23:30</b> Musica e Open Bar</p>
            <p><b>23:00-???</b> Festa</p>
          </div>

          <br>
          <b>Aggiornamento di Agosto</b>
          <li>E' meglio parcheggiare al parcheggio principale <a href="https://bit.ly/3AzjNxu">https://bit.ly/3AzjNxu</a><b>Abbiamo pass per il parcheggio PDF da stampare, fateci sapere se ne volete uno!</b></li>
          <li>Se non sapete cosa mettervi, opzionalmente potete mettere qualcosa di verde (anche un accessorio).</li>

          <br>
          <b>Aggiornamento di Luglio</b>
          <br>

          <p>Vi suggeriamo cortesemente di non farci regali fisici, dato che prenderemo un aereo per tornare in America 😊✈️.</p> 
          <p>Se siete interessati a contribuire alla nostra luna di miele in Grecia:</p>
          <p>PayPal <a href="https://paypal.me/sallyfrancesco">https://paypal.me/sallyfrancesco</a></p>
          <p>IBAN IT84F 02008 32974 001134845193, Francesco Rossi, Unicredit</p>


        {:else if language == 'kor'}
          <br>
          <p>Our wedding will take place on September 3, 2022 at <b>4.00PM</b> alla fortezza di <a href="https://www.san-leo.it/visita-san-leo/il-forte-rinascimentale/" target="blank">San Leo</a>, Italy.</p>

          <div style='border:1px; background-color: #fff0b5; border-radius: 16px; padding: 12px'>
            <p><b>Schedule</b></p>
            <b>☔️ IT WILL RAIN, WE ARE DOING THE plan B ☔️</b>
            <p><b>4:30pm Ceremony AT, THE Palazzo Mediceo San Leo, Piazza Dante Alighieri</b></p>
            <p><b>17:00-19:00</b> Aperitivo/Snack, Castle tours</p>
            <p><b>19:30-22:00</b> Dinner</p>
            <p><b>22:00</b> Cake</p>
            <p><b>22:00-23:30</b> Music and Open Bar</p>
            <p><b>23:00-???</b> Party</p>
          </div>

          <br>
          <b>August Update</b>
          <li>It is reccomended to park at the town parking <a href="https://bit.ly/3AzjNxu">https://bit.ly/3AzjNxu</a><b>We have parking passes in PDF to print, ping us for information!</b></li>
          <li>If you are renting a car or driving and staying at the hotel, the hotel will provide parking passes. Upon arrival at the San Leo Albergo Diffuso, leave your car at the gate and call or text the hotel at +39 389 543 5755. Then, you can check in, drop off your luggage, and receive the parking pass to go park your car.</li>
          <li>If you have not yet decided what to wear, optionally you are suggested to wear something green, the theme color (even an accessory).</li>

          <br>
          <b>July Update</b>
          <br>

          <p>We kindly suggest that you do not bring physical gifts to us in Italy, since we will be traveling back 😊✈️.</p> 
          <p>If you would like to contribute to our honeymoon in Greece:</p>
          <p>PayPal <a href="https://paypal.me/sallyfrancesco">https://paypal.me/sallyfrancesco</a></p>
          <p>IBAN IT84F 02008 32974 001134845193, Francesco Rossi, Unicredit</p>

          <br>

          <b>Transportation update</b>
          <p>The bus to San Leo will be leaving from Bologna at <b>1 PM</b> on September 2nd at Autostazione di Bologna , Piazza XX Settembre, 6, 40121 Bologna (Bo) and will take everyone to the hotel. It will take approximately 2 hours.</p>
          <p>It will take everyone from San Leo back to the same station in Bologna on September 4, leaving at 12.30PM.</p>

        {/if}
        <br/>
        <br/>
        
      </div>

    {:else if mode == 'rsvp'}
      <div id="rsvp">
        <iframe title="rsvp" src="https://docs.google.com/forms/d/e/1FAIpQLSdx5Ig9jJrUv8qW1-E25v-dKOer4I5b5pKds69q-IvcebmzoQ/viewform?embedded=true" width="720" height="800" frameborder="0" marginheight="0" marginwidth="0">
        Loading...
        </iframe>
      </div>

    {:else if mode == 'getthere'}
      <div id="getthere">
        <p>The venue is the historical <a href="https://en.wikipedia.org/wiki/Forte_di_San_Leo" target="blank">fortress of San Leo</a>, a <a href="https://en.wikipedia.org/wiki/San_Leo" target="blank">medieval town</a> built on top of a rock.</p>
        <p>The closest city is Rimini (~30 km away).</p>
        <p>The closest international airport is the Bologna airport (BLQ) (~100 km away). </p>

        <img src="/IMG_0424.jpg" alt="Town"/><br/>

        <h3>Flying</h3>

        <p><a href="https://www.google.com/travel/flights/flights-to-bologna.html" target="blank"><b>Bologna (BLQ)</b></a></p>
        <p>Train from Bologna to Rimini ~1.5 hours. We can pick you up in Rimini.</p>
        <p>Driving from Bologna to San Leo ~2 hours</p>
        <a href="https://www.google.com/travel/flights/flights-to-bologna.html" target="blank">Google Flights link</a>
        <br/>
        <p>If you would like to arrive or depart from another airport (to another city in Italy or Europe in general) you can find a train route that will take you to Bologna or Rimini. Rimini is the closest major city to San Leo and takes up to 1 hour by taxi or bus. Please feel free to contact us if you want advice on the flight/train ride based on where you would like to visit.</p>

        <p>Trenitalia (https://www.trenitalia.com/en.html) has many options for high-speed trains across Italy.</p>

        <p>Other good options to fly into would be Rome or Milan, however this would only be recommended if you are interested in visiting these cities and nearby areas. If not, it would be the most convenient to fly into Bologna (BLQ) airport.</p>

        <p><b>Rome (FCO)</b></p>
        <p>Train from Rome to Bologna ~2 hours</p>
        <p>Train from Rome to Rimini ~3.5 hours</p>
        <p>Driving from Rome to Rimini 4 hours</p>

        <p><b>Milan (MXP)</b></p>
        <p>Train from Milan to Bologna~1.5 hours</p>
        <p>Train from Milan to Rimini ~2.5 hours</p>
        <p>Driving from Milan to Rimini 3-4 hours</p>
        <br/>
      
        <h3>Getting to the San Leo fortress</h3>
        <p>The San Leo Castle is located at: Via Giacomo Leopardi, 47865 San Leo RN, Italy</p>
        <p>The castle is located on a hill. We will provide shuttles that will transport guests up to the castle from the base of the hill before the wedding starts, and it will also take guests down when the party is over. It is about a 10 minute walk uphill if you would like to walk.</p>

        <p>If you are driving to the venue on the day of the wedding, you will have to park at one of the public parking lots in San Leo near the castle. </p>
        <p>[Parking lot image/map?]</p>

        <h3>Accommodation in San Leo</h3>
        <p>We will provide an option to stay in a hotel in San Leo for guests from abroad who will be flying into Italy. The hotel is located at: Piazza Dante Alighieri, 11/12, 47865 San Leo RN, Italy</p>
        <p>The option will include a stay on the nights of September 2nd and 3rd with a check-out on the morning of September 4th. You will need to confirm on the RSVP form in order to secure a room in this hotel from our group.</p>

        <p>For those who will rent cars, we will provide parking passes for those who are staying at the hotel.</p>

        <p>It takes about 5 minutes to walk from the hotel to the venue.</p>

        <p>For those who will not be renting a car, there is a public bus that goes from Rimini to San Leo [add bus info here].</p>

        <p>Depending on the number of guests, we can provide a car that can take guests from Rimini to San Leo on September 2nd and from San Leo back to Rimini on September 4th. We will keep you updated on this, because we first need information from the RSVP numbers before we finalize this transport. </p>

        <h3>Travel Tips:</h3>
        <p>If you fly into Bologna</p>

        <p>If you fly into Milan</p>

        <p>If you fly into Rome</p>
      </div>

    {:else if mode == 'map'}
      <h2>Map of Guests</h2>

    {:else if mode == 'italy'}
      <div id="italy">

        <p>Work in progress!</p>

        <p>Our favorite Art Cities: Venice, Rome, Florence, Naples. There is a efficient fast train network (trenitalia.it / lefrecce / italo) that connects all of them in an hour or two.</p>

        <p>Our favorite Mountains: Dolomites (Ortisei).</p>

        <p>Our favorite Island: Capri/Ischia (Naples).</p>
      </div>
  
    {:else if mode == 'beppe'}
      <div id="beppe">
        <h2>Special Guest Beppe Crosta</h2>
        <img src="/beepsheart.png" alt="Beppe"/><br/><br/>
        <a href="https://www.instagram.com/beppecrosta/?hl=en" target="blank">Instagram Profile</a>
      </div>
    {/if}
  </div>
    
{#if 0}

    <h1>💪🔥 Mode Activated</h1>

    <p>
      <strong>Tip:</strong>
      Open the browser console for development logging.
    </p>


    <!-- 2. 😀 Get the current user -->
    <User let:user let:auth>
      Howdy 😀! User
      <em>{user.uid}</em>

      <button on:click={() => auth.signOut()}>Sign Out</button>

      <div slot="signed-out">

        <button on:click={() => auth.signInAnonymously()}>
          Sign In Anonymously
        </button>
      </div>

      <hr />

      <!-- 3. 📜 Get a Firestore document owned by a user -->
      <Doc path={`posts/${user.uid}`} let:data={post} let:ref={postRef} log>

        <h2>{post.title}</h2>

        <p>
          Document
          created at <em>{new Date(post.createdAt).toLocaleString()}</em>
        </p>

        <span slot="loading">Loading post...</span>
        <span slot="fallback">
          <button
            on:click={() => postRef.set({
                title: '📜 I like Svelte',
                createdAt: Date.now()
              })}>
            Create Document
          </button>
        </span>

        <!-- 4. 💬 Get all the comments in its subcollection -->

        <h3>Comments</h3>
        <Collection
          path={postRef.collection('comments')}
          query={ref => ref.orderBy('createdAt')}
          let:data={comments}
          let:ref={commentsRef}
          log>

          {#if !comments.length}
              No comments yet...
          {/if}

          {#each comments as comment}
            <p>
              <!-- ID: <em>{comment.ref.id}</em> -->
            </p>
            <p>
              {comment.text}
              <button on:click={() => comment.ref.delete()}>Delete</button>
            </p>
          {/each}


          <button
            on:click={() => commentsRef.add({
                text: '💬 Me too!',
                createdAt: Date.now()
              })}>
            Add Comment
          </button>

          <span slot="loading">Loading comments...</span>

        </Collection>
      </Doc>
    </User>
    {/if}
  
  </FirebaseApp>

</main>

